import { Box, Flex } from "@chakra-ui/react";
import React from "react";

import { Card, CardTitle } from "../../../components/Card";
import { SettingsNavLink } from "../../../components/SettingsNavLink";
import { Tab } from "../../types";

const MasterListView: React.FC<{
  tabs: Tab<any>[];
  urlPrefix: string;
  title?: string;
}> = ({ tabs, urlPrefix, title }) => (
  <Box>
    <Card>
      {title && <CardTitle position="relative">{title}</CardTitle>}
      <Flex flexDirection="column">
        {tabs.map((tab, i) => (
          <SettingsNavLink
            key={`list-${tab.path}`}
            to={`${urlPrefix}/${tab.startingPath || tab.path}`}
            data-testid="master-detail--link"
          >
            {tab.name}
          </SettingsNavLink>
        ))}
      </Flex>
    </Card>
  </Box>
);

export default MasterListView;
